//Use this class as a model for future services.
//No Custom Repository Class is required 

import { Tag } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class TagService {
    
    

	getNew(): Tag {
		return this.repository.getNewEntity();
	}

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(Tag);
	}

	//Matches /api/tag on server.
	getTags() {
		return this.repository.find();
	}

	////Matches /api/tag/get-tags'
	//getTags() {
	//	return this.repository.find("get-tags");

	//}

	




}